export const en = {
  "alert": {
    "no_assignment_theory_found": "There is no theory available."
  },
  "arrangement": {
    "assignments": {
      "adaptive_title": "We recommend you complete the exercise block '{{advise}}' based on a score of:",
      "button_title_next": "Next exercise",
      "button_title_previous": "Previous exercice",
      "collapse": "Hide results",
      "collapse_adaptive": "Hide subsequent blocks",
      "complete": {
        "submit": "Finish",
        "submit_text": "All exercises have been completed. Submit your self-test to view your results."
      },
      "expand": "Show results",
      "expand_adaptive": "Show subsequent blocks",
      "legend": {
        "answer_send": "Answer has been submitted",
        "draft": "Answer is not finished yet",
        "open_question": "Open question",
        "review_available": "You can now check your answer",
        "title": "Legend"
      },
      "next": "Next exercise",
      "previous": "Previous exercise",
      "results": "results",
      "self_test": {
        "begin": "Start",
        "body": "You can pause the self-test. All saved answers will be kept.",
        "introduction": "Introduction",
        "next_self_score": "To next open exercise",
        "result": "Result",
        "results": "To results",
        "resume": "Continue",
        "selfscore": {
          "multiple": "Give yourself a score for multiple exercises based on a model answer.",
          "single": "Give yourself a score for one exercise based on a model answer."
        },
        "submit": "Submit",
        "submit_text": "You have completed all exercises. Submit to check your answers."
      },
      "tooltip_self_score": "Self-assessment exercise"
    },
    "block": {
      "exercises": "Exercises",
      "score": "Score"
    },
    "overview": {
      "button": {
        "continue": "Continue",
        "results": "View",
        "show": {
          "results": "View results"
        },
        "start": "Start"
      },
      "label": {
        "start": "Start with your course material"
      }
    },
    "references": "References",
    "tab": {
      "assignments": "Exercises",
      "contents": "Course material",
      "exercises": "Exercises",
      "learning_goals": "Learning goals",
      "sources": "Resources",
      "terms": "Terms",
      "theory": "Theory"
    }
  },
  "assignment": {
    "action": {
      "correct": "Well done! This answer is correct.",
      "incorrect": "This is not the correct answer.",
      "missed": "This answer is right, but you didn't choose it.",
      "predefined": "This answer has been pre-filled for you and is correct."
    },
    "actions": {
      "close": "Close",
      "primary": {
        "check": "Check",
        "complete": "Exercise completed",
        "save": "Save",
        "save_edited": "Save modified answer",
        "submit": "Submit"
      }
    },
    "feedback": {
      "deleted_result": "Your teacher has deleted the answer so you can redo the exercise.",
      "deleted_sequence_result": "Your teacher has deleted the answers from the self-test so you can redo the exercises.",
      "reset_score": "Your teacher has deleted the answer so you can redo the exercise.",
      "teacher_message": "Message from your teacher"
    },
    "loading": "The exercise is loading...",
    "question": {
      "result": {
        "actions": {
          "check_results": "View results",
          "hide_answer": "Hide answer",
          "next_question": "Next exercise",
          "show_answer": "Show answer"
        },
        "check_results": "You can now view the results.",
        "info": {
          "hide_answer": "Hide the answer to complete the exercise."
        },
        "next_question": "Continue to the next exercise",
        "primary": {
          "check": "Complete the exercise above. Once you're done, you can check your answer.",
          "complete": "Complete the exercise above. You can finish once you've completed the exercise.",
          "submit": "Complete the exercise above. You can submit your answer when you're done."
        },
        "review_disabled": "The review of your answer has been disabled. If you want to assess yourself, ask your teacher to enable the review again.",
        "self_score": {
          "actions": {
            "confirm_score": "Confirm score"
          },
          "check_answer_and_score": "Nice! Review your answer and give yourself a score above.",
          "confirm_score": "Well done, you can now confirm your score."
        },
        "statuses": {
          "checked": {
            "actions": {
              "show_answer": "Show answer",
              "show_answer_info": "Can't figure it out? You can view the correct answers. Your current score of {{score}}% can no longer be improved.",
              "try_again": "Try again",
              "try_again_info": "(1)[first attempt];(2)[second attempt];(3)[third attempt];(4)[fourth attempt];(5)[fifth attempt];(6)[sixth attempt];(7)[seventh attempt];(8)[eighth attempt];(9)[ninth attempt];(10)[tenth attempt];(11-inf)[attempt {{count}}]"
            },
            "max_score": "Well done! You have completed this exercise.",
            "try_again": "Hmm, your answer wasn't quite right. Try again."
          },
          "completed": {
            "attempt": "(1)[Score after first attempt];(2)[Score after second attempt];(3)[Score after third attempt];(4)[Score after fourth attempt];(5)[Score after fifth attempt];(6)[Score after sixth attempt];(7)[Score after seventh attempt];(8)[Score after eighth attempt];(9)[Score after ninth attempt];(10)[Score after tenth attempt];(11-inf)[Score after attempt {{count}}]",
            "default_one": "Your score for this exercise is {{score}}% after {{count}} attempt.",
            "default_other": "Your score for this exercise is {{score}}% after {{count}} attempts.",
            "default_zero": "Your score for this exercise is {{score}}% after {{count}} attempts.",
            "done": "You have completed this exercise.",
            "message": "Well done! You have completed this exercise.",
            "message_closed": "Answer displayed",
            "score": "score",
            "self_score": "Your score for this exercise is {{score}}%."
          },
          "submitted": {
            "actions": {
              "duplicate_value": "This answer is the same as a previously given answer.",
              "try_again_info": "The answer has been saved. You can still change your answer."
            }
          }
        },
        "validation": {
          "invalid": "Your answer is not completely correct yet.",
          "max": "You have exceeded the maximum number of answers."
        }
      },
      "validation": {
        "max": "You have selected too many answers."
      }
    },
    "results": {
      "average_score_no_scores": "You have completed exercises for which you won't receive a score.",
      "average_score_text": "So far, you have an average score of {{score}} on the completed exercises.",
      "average_score_title": "Average score",
      "average_score_title_selftest": "Score: {{score}}",
      "average_score_title_with_score": "Average score: {{score}}",
      "back": "View all your exercises",
      "legenda": {
        "open_assignment": "Open question",
        "title": "Legend:"
      },
      "loading": "The results are loading...",
      "progress_text": "You have completed {{count}} out of {{total}} exercises.",
      "progress_title": "Your progress",
      "progress": {
        "completed": "You have completed this exercise block with a score of",
        "completed_no_score": "You have completed this exercise block.",
        "incomplete": "You have not completed all the exercises yet."
      },
      "questions_title": "Result per exercise",
      "questions": {
        "done": "The exercises are sorted by score. You can review the exercises with the lowest scores.",
        "todo": "Answer the following exercises to complete the exercise block."
      },
      "test_ended": "Submitted on {{date}} at {{time}}.",
      "test_started": "Started on {{date}} at {{time}} hours.",
      "title": "Results",
      "title_selftest": "Results: Self-test"
    },
    "score": {
      "message": {
        "excellent": "Great job, keep it up!",
        "marginal": "On the right track. Practice a bit more!",
        "poor": "No worries! Learn from the feedback and try again.",
        "satisfactory": "Well done! This is a great score.",
        "unsatisfactory": "You can do better! Practice a bit more."
      }
    },
    "sidebar": {
      "back": "Exercise overview",
      "back-to-theory": "To theory",
      "nav": {
        "introduction": "Introduction",
        "results": "Results"
      },
      "navigation": {
        "aria-label": {
          "close": "Close Table of Contents",
          "collapse": "Collapse Table of Contents",
          "expand": "Expand Table of Contents",
          "open": "Open Table of Contents"
        }
      },
      "secondary": {
        "nav": {
          "book": "Guide",
          "sources": "References",
          "terms": "Terms",
          "theory": "Theory"
        },
        "title": "Tools"
      },
      "tools": {
        "aria-label": {
          "close": "Close theory",
          "material": "{{ material }} opens in a new window.",
          "open": "Open theory"
        }
      }
    },
    "status": {
      "answered": "Answer has been submitted",
      "checkingAvailable": "You can now check your answer",
      "default": "Not yet completed",
      "disabled": "Available after start of self-test",
      "done": "Answer has been checked",
      "draft": "Answer has not yet been submitted"
    },
    "theory": {
      "alert": {
        "no_assignment_theory_found": "There is no theory available for these exercises."
      },
      "close-theory": "Close theory"
    }
  },
  "button": {
    "adjust": "Edit",
    "cancel": "Cancel",
    "delete": "Remove",
    "save": "Save"
  },
  "common": {
    "activation_code": "Activation code",
    "add": "Add",
    "back": "Back",
    "back_to_top": "Back to top",
    "change_email": "change email address",
    "confirm_password": "Confirm password",
    "create_account": "Create account",
    "email": "Email address",
    "email_not_validated": "Your email address has not been confirmed yet. Check your inbox for the confirmation email or request a new one.",
    "email_placeholder": "name@email.com",
    "error_occurred": "An unexpected error has occurred",
    "field_required": "This field is required",
    "first_name": "First name",
    "first_name_required": "First name is required.",
    "forgot_password": "Forgot password",
    "forgot_password_question": "Forgot password?",
    "invalid_email": "This is not a valid Email.",
    "last_name_required": "Last name is required.",
    "login": "Sign in",
    "logout": "Log out",
    "next": "Next",
    "password": "Password",
    "password_missing_lowercase": "The password must contain at least one lowercase letter.",
    "password_missing_number": "The password must contain at least one number.",
    "password_missing_special_character": "The password must contain at least one special character (!@#$%^&*()?><€=_+-).",
    "password_missing_uppercase": "The password must contain at least one uppercase letter.",
    "password_too_short": "The password must be at least 9 characters long.",
    "passwords_do_not_match": "Passwords do not match",
    "repeat_password": "Repeat password",
    "reset_password": "Reset password",
    "surname": "Surname",
    "surname_prefix": "Surname Prefix",
    "surname_prefix_label": "Surname Prefix (optional)",
    "table_of_contents": "Table of Contents",
    "toegang_error_unknown": "Something went wrong while logging in. Please try again later.",
    "toegang_invalid_token": "The login session is invalid. Please try logging in again.",
    "toegang_token_expired": "The login session has expired. Please try logging in again.",
    "toegang_user_not_found": "No account was found for this Toegang user."
  },
  "content": {
    "figure": {
      "fallback-label": "Source {{addition}}"
    },
    "frame": {
      "label": {
        "case": "Case",
        "context": "Context",
        "dialogue": "Dialogue",
        "example": "Example",
        "explanation": "Explanation",
        "summary": "Summary"
      }
    },
    "interactions": {
      "drawing_canvas": {
        "actions": {
          "clear": "Erase all"
        }
      },
      "model_answer": "Model answer",
      "self_score": {
        "open_text": {
          "title": "Review your answer:"
        },
        "rubric_group": {
          "weight": "Determines {{weight}}% of the total score."
        },
        "rubric": {
          "completed": "This is the total score you gave yourself for this exercise.",
          "explanation": "The score is made up of the following components:",
          "next_group": "Next rating",
          "prev_group": "Previous rating",
          "title": "\"Review your answer yourself and choose an appropriate score:"
        },
        "scale": {
          "explanation": "This is the score you gave to your submitted answer:",
          "title": "How accurate is your answer?"
        }
      },
      "speaking": {
        "action_listen": {
          "label": "Listen"
        },
        "action_play": {
          "instruction": "Recording",
          "label": "Play"
        },
        "action_record": {
          "instruction": "Hold down",
          "label": "Record"
        },
        "score": {
          "excellent": "Well done!",
          "poor": "This could be better. Listen carefully to the words with an underscore underneath.",
          "satisfactory": "Almost right, try again!",
          "unsatisfactory": "Good attempt, but it can be better. Listen carefully again to the words with an underscore underneath"
        }
      },
      "upload": {
        "drop_dragging_file": "Drop your image to upload",
        "drop_file": "Upload an image",
        "dropped_file": "Your file has been uploaded!",
        "placeholder": "Drag an image here or select an image",
        "select_file": "Select image",
        "uploading": "Uploading image..."
      },
      "validators": {
        "max": "You have exceeded the maximum number of answers.",
        "min": "The minimum value is {{min}}",
        "must-contain": "Your answer must contain '{{mustContain}}'",
        "required": "You must provide an answer"
      },
      "your_answer": "Your answer"
    },
    "quote": {
      "author": {
        "title": "Author of the quote"
      }
    },
    "remark": {
      "label": {
        "attention": "Attention!",
        "hint": "Hint",
        "tip": "Tip"
      }
    },
    "score-label": {
      "completed": "Exercise completed"
    }
  },
  "footer": {
    "copyright": "Copyright",
    "disclaimer": "Disclaimer",
    "privacy-policy": "Privacy policy",
    "terms-and-conditions": "Terms and Conditions"
  },
  "label": {
    "theory": "Theory"
  },
  "landing": {
    "main": {
      "label_all_arrangements": "All instructional materials",
      "label_continue": "Continue",
      "label_user_defined_arrangements": "Instructional materials prepared by your teacher"
    },
    "view_all": "All instructional materials"
  },
  "onegate": {
    "forgot_password_success": {
      "message": "We’ve sent you an email so you can\nset a new password.",
      "title": "Email sent"
    },
    "forgot_password": {
      "info": "We will send you a link to the following email address so you can set a new password.",
      "send_link": "Send me the link"
    },
    "initiate_set_password_success": {
      "message": "If an account exists for this email address, we've sent you an email with a new link to set your password.",
      "title": "Email sent"
    },
    "initiate_set_password": {
      "info": "Enter your email address to receive a link to set your password.",
      "send_link": "Send me the link",
      "title": "Set your password"
    },
    "institution_invitation": {
      "error": {
        "codes": {
          "internal_error": "Something went wrong. Please try again later.",
          "invalid_link": "This link is invalid or corrupted. Please request a new link from your administrator.",
          "not_found": "This invitation could not be found or has expired.",
          "unknown": "The link could not be completed."
        },
        "title": "Linking failed"
      },
      "success": {
        "continue_button": "Go to my licenses",
        "message": "You are now linked as administrator of the institution.",
        "title": "Institution linked"
      }
    },
    "licenses": {
      "activation_code_tooltip": "You will find this code in your teaching materials or in your email.",
      "error": {
        "code_already_used": "This activation code has already been used",
        "code_invalid": "This is not a valid activation code",
        "code_unknown": "This activation code is unknown",
        "unknown": "Unknown activation code"
      },
      "expired_since": "Expired since",
      "leave": "To the classes",
      "list_title": "Your licenses ({{count}})",
      "no_active_licenses": "This account doesn’t have an active license yet.",
      "no_license": {
        "student_bold": "Are you an NT2 student?",
        "student_link": "learning materials list",
        "student_text": "Buy your books with licenses at your local bookstore or online via bol.com. Check the",
        "student_text_after": "of your school and ask your teacher which books you need.",
        "teacher_bold": "Are you a teacher?",
        "teacher_link": "Thiememeulenhoff webshop",
        "teacher_text": "Visit the",
        "teacher_text_after": "to buy a license or teaching materials.",
        "title": "No license yet?"
      },
      "title": "Manage licenses",
      "title_new_user": "One more step to get started",
      "valid_until": "Valid until"
    },
    "login": {
      "email_not_found": "This email address isn’t recognized. Change above email address or ‘create your account’ below.",
      "error": {
        "email_not_validated": "Your email address has not been confirmed yet. Check your inbox for the confirmation email or request a new one.",
        "password_incorrect": "The combination of username/email address and password is incorrect.",
        "resend_validation_email": "Resend validation email",
        "title": "Login failed"
      },
      "header": "Sign in to your account",
      "header_password": "Enter your password",
      "login_with_email": "Sign in with email",
      "validation_email_resent": "We sent you a new validation email. Check your inbox."
    },
    "password_tooltip": "The password must meet the following requirements: A minimum length of 9 characters; A minimum of 1 numeric character (0 to 9); A minimum of 2 alphanumeric characters, of which 1 uppercase letter (A to Z) and 1 lowercase letter (a to z); A minimum of 1 special character (for example !@#$%^&*()?><€=_+-).",
    "register_success": {
      "message": "We have sent you a verification email. Click the link in the email to confirm your account and log in.",
      "title": "Verify your account"
    },
    "register": {
      "error": {
        "user_already_exists": "An account with this email address already exists."
      },
      "header": "Create your account"
    },
    "reset_password_success": {
      "message": "You password has been successfully changed",
      "title": "Password changed"
    },
    "reset_password": {
      "change_button": "Change password",
      "info": "Enter a new password twice below to restore the password for the email address:"
    },
    "set_password_success": {
      "message": "Your password has been set successfully. You can now log in.",
      "title": "Password set"
    },
    "set_password": {
      "error": {
        "password_already_set": "A password has already been set for this account. Try logging in or use 'Forgot password'.",
        "token_invalid": "This link is invalid or has expired. Please request a new link."
      },
      "info": "Enter a password twice to activate the account for the email address below:",
      "invalid_token": "This link is invalid or has expired.",
      "submit_button": "Set password",
      "title": "Set your password"
    },
    "unknown_error": "An unexpected error has occurred",
    "validation_success": {
      "message": "Your account has been successfully verified. You can now log in.",
      "title": "Account verified"
    },
    "verify_set_password_token": {
      "error": {
        "token_invalid": "This link is invalid or has expired. Please request a new link."
      }
    }
  },
  "teacher-material": {
    "articles": {
      "learning_time_indicator": "{{ amount }} minutes"
    }
  }
}
